import { BaseService } from './base.service';
import { FeathersService } from './feathers.service';
import { Injectable } from '@angular/core';
import { IConfig } from '@alberta/konexi-shared';

@Injectable({
  providedIn: 'root',
})
export class ConfigService extends BaseService<IConfig> {
  constructor(feathers: FeathersService) {
    super('config', feathers.app);
  }
}
